import { useEffect, useState } from "react";

import { Container, Offcanvas } from "react-bootstrap";
import { useSelector } from "react-redux";

import SntCloseIcon from "@icons/SntCloseIcon";

import SidebarBody from "./SidebarBody";
import SidebarLogo from "./SidebarLogo";

import CloudWhiteIcon from "@images/cloud-logo-white.svg";
import CloudBlueIcon from "@images/cloud-icon-blue-01-32x32.png";

import { RootState } from "@/types/RootState";

function Sidebar(): JSX.Element {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const { logoPath, menuType, showCanvasMenu } = useSelector(
    (state: RootState) => state.all
  );
  const { isMobile } = useSelector((state: RootState) => state.all);
  const loginInfo = useSelector((state: RootState) => state.user);

  useEffect(() => {
    setShowMenu(showCanvasMenu ?? false);
  }, [showCanvasMenu]);

  // only close when click on link of sidebar
  const onOffCanvasClicked = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.preventDefault();
    if (
      (e.target as HTMLElement).classList.contains("nav-link") ||
      (e.target as HTMLElement).classList.contains("sidebar-normal")
    ) {
      if (showMenu) {
        setShowMenu(false);
      }
    }
  };

  // Every login gets the 6.0.3 menu branding: a full-height coloured sidebar
  // with its logo at the top, deliberately covering the header's left edge. One
  // place for the mark, on a background chosen for it — the Sensolus wordmark by
  // default, the organisation's own upload where branding is configured.
  //
  // `sidebar-with-logo` no longer distinguishes anything (System and partners
  // were excluded for a while under STIC-15365); it stays because the SCSS uses
  // the compound selector to outrank the base `.sidebar` rules.
  return !isMobile ? (
    <Container>
      <div
        className="sidebar snt-sidebar sidebar-with-logo"
        data-color={menuType === "MAIN" ? "home" : "admin"}
      >
        <SidebarLogo logoPath={logoPath} />
        <SidebarBody />
      </div>
    </Container>
  ) : (
    <Container>
      <Offcanvas
        show={showMenu}
        onHide={() => {
          setShowMenu(false);
        }}
        enforceFocus={false}
        style={{
          width: "100%",
          backgroundColor: menuType === "MAIN" ? "#4E5471" : "#EFF3F4",
        }}
        collapseonselect={"true"}
      >
        <div>
          <div className="text-center" style={{ marginTop: 5 }}>
            {isMobile && loginInfo.custumInfo === undefined && (
              <img
                src={menuType === "MAIN" ? CloudWhiteIcon : CloudBlueIcon}
                style={{ width: 32, height: 32 }}
                alt={"Logo"}
              />
            )}
          </div>
          <SntCloseIcon
            size={20}
            style={{
              color: menuType === "MAIN" ? "white" : "grey",
              position: "absolute",
              right: 13,
              top: 13,
            }}
            onClick={() => setShowMenu(false)}
          />
        </div>
        <Offcanvas.Body className="p-0" onClick={onOffCanvasClicked}>
          <div
            className="sidebar snt-sidebar sidebar-with-logo"
            data-color={menuType === "MAIN" ? "home" : "admin"}
          >
            <SidebarLogo logoPath={logoPath} />
            <SidebarBody />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default Sidebar;
